import { render } from "./ListsBounces.vue?vue&type=template&id=cdbb2c3a"
import script from "./ListsBounces.vue?vue&type=script&lang=ts"
export * from "./ListsBounces.vue?vue&type=script&lang=ts"
script.render = render

export default script